export enum OrdersActionTypes {
	SET_ORDERS = "ORDERS/SET_ORDERS",
	SET_ORDER = "ORDERS/SET_ORDER",
	SET_ORDER_STATE = "ORDERS/SET_ORDER_STATE",
}

export enum ProductsActionTypes {
	SET_PRODUCTS = "PRODUCTS/SET_PRODUCTS",
}
